/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M17 5L22 10L17 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 10L13 5M18 10L13 15M18 10H6.8C5.11984 10 4.27976 10 3.63803 10.327C3.07354 10.6146 2.6146 11.0735 2.32698 11.638C2 12.2798 2 13.1198 2 14.8V16.5V17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M17 5L22 10L17 15M18 10L13 5M18 10L13 15M18 10H5.2C4.07989 10 3.51984 10 3.09202 10.218C2.71569 10.4097 2.40973 10.7157 2.21799 11.092C2 11.5198 2 12.0799 2 13.2V16.5V17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M17 5L22 10L17 15M18 10L13 5M18 10L13 15M18 10H5.2C4.07989 10 3.51984 10 3.09202 10.218C2.71569 10.4097 2.40973 10.7157 2.21799 11.092C2 11.5198 2 12.0799 2 13.2V16.5V17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M13 5L18 10H6.8C5.11984 10 4.27976 10 3.63803 10.327C3.07354 10.6146 2.6146 11.0735 2.32698 11.638C2 12.2798 2 13.1198 2 14.8V16.5V17M13 15L15.5 12.5M17 5L22 10L17 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M17 5L22 10L17 15M18 10L13 5M18 10L13 15M18 10H5.2C4.07989 10 3.51984 10 3.09202 10.218C2.71569 10.4097 2.40973 10.7157 2.21799 11.092C2 11.5198 2 12.0799 2 13.2V16.5V17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M17 5L22 10L17 15M18 10L13 5M18 10L13 15M18 10H5.2C4.07989 10 3.51984 10 3.09202 10.218C2.71569 10.4097 2.40973 10.7157 2.21799 11.092C2 11.5198 2 12.0799 2 13.2V16.5V17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
